/**
 * @see https://www.jsonrpc.org/specification#error_object
 */
export const ErrorCodes = {

	'-32700': {
		short: 'Parse error',
		long: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.'
	},
	'-32600': {
		short: 'Invalid Request',
		long: 'The JSON sent is not a valid Request object.'
	},
	'-32601': {
		short: 'Method not found',
		long: 'The method does not exist / is not available.'
	},
	'-32602': {
		short: 'Invalid params',
		long: 'Invalid method parameter(s).'
	},
	'-32603': {
		short: 'Internal error',
		long: 'Internal JSON-RPC error.'
	},
	'-32000': {
		short: 'Server error',
		long: 'Reserved for implementation-defined server-errors.'
	}
}
